
import { useAuth } from '@common/auth/use-auth';
import {Trans} from '@common/i18n/trans';
import { useTrans } from '@common/i18n/use-trans';
import { Button } from '@common/ui/buttons/button';
import React, {Fragment, ReactNode, useEffect, useState} from 'react';
import { FormTextField, TextField } from '@common/ui/forms/input-field/text-field/text-field';
import {Item} from '@common/ui/forms/listbox/item';

import {SubmitHandler, UseFormReturn, useForm} from 'react-hook-form';
import {Form} from '@common/ui/forms/form';
import { FormSelect } from '@common/ui/forms/select/select';
import { Prompt } from '@app_modules/chats/prompt';
// import { useMyLoanPrograms } from '@app_modules/requests/use-my-loan-programs';
import { useSettings } from '@common/core/settings/use-settings';
import { LoanProgram } from '@app_modules/loan-products/loan-program/loan-program';
import { slugifyString } from '@common/utils/string/slugify-string';
import { useMyLoanPrograms } from '@app_modules/requests/use-my-loan-programs';
import { ViewChatDemoLayout } from './view-chat-demo-layout';
import { useDemoChat } from '@app_modules/requests/use-demo-chat';


export function ChatLendermacDemoPage({changeLoanProgram}: any) {
  const {trans} = useTrans();
  const {user} = useAuth();
  
  const [newMessage, setNewMessage] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    setMessage(newMessage);
  }, [newMessage])


  return (
    <Fragment>
      <div className='flex gap-10 m-20'>
        <div className='w-[30%] pr-10 border-r-1 sticky'>
          <AddPrompt newMessage={setNewMessage} changeLoanProgram={changeLoanProgram}/>
        </div>
        <div className='w-[70%]'>
          <ViewChatDemoLayout
            title={
              <Trans message="Product Finder"/>
            }
            // isLoading={viewReport.isPending}
          >
          <fieldset className="w-full border-2 border-t-2 min-h-[600px]">
            <TextField
                className='form-input'
                name='message'
                value={message ? message : ''}
                inputElementType="textarea"
                rows={40}
                onChange={e => {
                  
                }}             
              />
          </fieldset>
          </ViewChatDemoLayout>
        </div>
      </div>
      
    </Fragment>
  );
}

// Parent component
function AddPrompt({ newMessage, changeLoanProgram }: { newMessage: any; changeLoanProgram: any }) {
  const form = useForm<Prompt>({
    defaultValues: {
      prompt: '',
      lender_id: 'lendermac',
    },
  });

  const sendChat = useDemoChat(form);
  

  return (
    <AddPromptForm
      form={form}
      onSubmit={(values) => {
        sendChat.mutate(values, {
          onSuccess: (response: any) => {
            newMessage(response.data);
          },
        });
      }}
      isLoading={sendChat.isPending}
      changeLoanProgram={changeLoanProgram}
      changePrompt={(value: string) => form.setValue('prompt', value, { shouldDirty: true })}
    />
  );
}

// Props interface for AddPromptForm, using Prompt directly
interface Props {
  onSubmit: SubmitHandler<Prompt>;
  form: UseFormReturn<Prompt>;
  isLoading?: boolean;
  disableSaveWhenNotDirty?: boolean;
  changeLoanProgram: (value: string) => void;
  changePrompt: (value: string) => void;
}

// AddPromptForm component
export function AddPromptForm({
  onSubmit,
  form,
  isLoading = false,
  disableSaveWhenNotDirty = false,
  changeLoanProgram,
  changePrompt,
}: Props) {
  const isDirty = !disableSaveWhenNotDirty
    ? true
    : Object.keys(form.formState.dirtyFields).length;

  const { trans } = useTrans();
  const { data: myPrograms } = useMyLoanPrograms();
  const programs = myPrograms?.programs;
  const { uw } = useSettings();
  // Safely parse instructions with error handling
  let instructions: string[] = [];
  if (uw && uw.instructions) {
    try {
      instructions = JSON.parse(uw.instructions);
    } catch (e) {
      console.error('Failed to parse instructions:', e);
    }
  }



  // Update form's prompt field and parent state when instruction changes
  // Update form's prompt field and parent state when instruction changes
  const changeInstruction = (name: string) => {
    const key = slugifyString(name, '_'); // Convert instruction name to slug
    const instruction_prompt = key && uw ? uw[key.toString() + '_prompt'] ?? '' : '';
    form.setValue('prompt', instruction_prompt, { shouldDirty: true }); // Type-safe with UseFormReturn<Prompt>
    changePrompt(instruction_prompt); // Update parent component's prompt state
  };

  return (
    <Form
      onSubmit={onSubmit}
      onBeforeSubmit={() => form.clearErrors()}
      form={form}
    >
      <div className="flex flex-wrap">
        <div className="items-center text-xs w-[100%]">
          <FormSelect
            size="sm"
            name="lender_id"
            selectionMode="single"
            autoFocus
            required
            placeholder={trans({ message: 'Select workspace' })}
            className="w-150 mb-10"
            defaultValue={'lendermac'}
            onSelectionChange={(val: any) => {
              changeLoanProgram(val.toString());
            }}
          >
            <Item value="lendermac" key="lendermac">
              <Trans message="LenderMAC" />
            </Item>
          </FormSelect>

          <FormSelect
            size="sm"
            name="document_type"
            selectionMode="single"
            required
            placeholder={trans({ message: 'Instruction Template' })}
            className="w-150 mb-10"
            onSelectionChange={(val: any) => {
              changeInstruction(val.toString());
            }}
          >
            {instructions?.map((instruction: string) => (
              <Item value={instruction} key={instruction}>
                <Trans message={instruction} />
              </Item>
            ))}
          </FormSelect>

          <FormTextField
            className="form-input"
            inputElementType="textarea"
            rows={28}
            name="prompt"
            placeholder="Enter your prompt"
          />
        </div>
        <div className="text-md w-full m-10 flex justify-center">
          <Button
            variant="flat"
            color="green"
            type="submit"
            disabled={isLoading || !isDirty}
          >
            <Trans message="Find Product(s)" />
          </Button>
        </div>
      </div>
    </Form>
  );
}

